export default __webpack_public_path__ + "static/ksi-91d3b5d2a15f1d8edb7dd4061618b0cd.png";